import { render, staticRenderFns } from "./PlaceFormModal.vue?vue&type=template&id=0c237bd1&"
import script from "./PlaceFormModal.vue?vue&type=script&lang=js&"
export * from "./PlaceFormModal.vue?vue&type=script&lang=js&"
import style0 from "./PlaceFormModal.vue?vue&type=style&index=0&id=0c237bd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports